import axios from "axios";
import GetCookieByName from "../hooks/GetCookie";

// const config = require("../config/settings.json");
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

let authToken;

function setToken(token) {
  authToken = token;
  if (!axios.defaults.headers.common["x-auth-token"])
    axios.defaults.headers.common["x-auth-token"] = token;
}

try {
  const raw = GetCookieByName("auth");
  if (typeof raw === "string") {
    const parsed = JSON.parse(raw);
    if (parsed?.token) setToken(parsed.token);
  }
} catch {
  // cookie missing or not valid JSON — requests will auth via per-call headers
}

// axios.interceptors.request.use((config) => {
//   if (authToken && !config.headers["x-auth-token"]) {
//     config.headers["x-auth-token"] = authToken;
//   }

//   if (!config.headers['x-fy']) {
//     config.headers['x-fy'] = "All";
//   }
//   return config;
// });
axios.interceptors.request.use((config) => {
  if (!config.headers["x-auth-token"]) {
    try {
      const raw = GetCookieByName("auth");
      const parsed = JSON.parse(raw);
      if (parsed?.token) {
        config.headers["x-auth-token"] = parsed.token;
      }
    } catch {
      // no valid auth cookie — request proceeds without token
      console.log('Error')
    }
  }

  if (!config.headers["x-fy"]) {
    config.headers["x-fy"] = "All";
  }

  return config;
});

axios.interceptors.response.use(null, (error) => {
  return Promise.reject(error);
});

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
  // cancel: axios.CancelToken
};

export default http;
